import React from 'react';
import { BadgeCheck } from 'lucide-react';
export function TestimonialCarousel() {
  return <section className="my-12" data-id="element-281">
      <h2 className="text-[24px] font-bold text-[#1a1a1a] mb-8 font-serif border-b border-[#E5E5E0] pb-4" data-id="element-282">
        What Readers Are Saying
      </h2>

      <div className="space-y-10" data-id="element-283">
        <div className="relative pl-6" data-id="element-284">
          <span className="absolute left-0 top-0 text-[40px] leading-none text-[#E5E5E0] font-serif font-bold" data-id="element-285">
            "
          </span>
          <p className="text-[18px] italic text-[#1a1a1a] mb-3 font-serif leading-relaxed" data-id="element-286">
            I was terrified of stairs. After two weeks with this method, I
            realized I hadn't braced once going down my front steps. That's when
            I knew something had changed. The traffic light system is genius—it
            took the guesswork out completely.
          </p>
          <div className="flex items-center gap-2" data-id="element-287">
            <span className="text-[12px] font-bold text-[#1a1a1a] font-sans uppercase tracking-wide" data-id="element-288">
              Margaret W.
            </span>
            <span className="text-[12px] text-[#888] font-sans" data-id="element-289">
              Phoenix, AZ
            </span>
            <BadgeCheck size={12} className="text-[#8B2500]" data-id="element-290" />
          </div>
        </div>

        <div className="relative pl-6" data-id="element-291">
          <span className="absolute left-0 top-0 text-[40px] leading-none text-[#E5E5E0] font-serif font-bold" data-id="element-292">
            "
          </span>
          <p className="text-[18px] italic text-[#1a1a1a] mb-3 font-serif leading-relaxed" data-id="element-293">
            I've tried three different PT programs and quit all of them because
            they flared me up. This one actually respects sensitive days. Day 7
            I noticed my knee felt "quieter." By day 12, I walked the grocery
            store without my cane for the first time in months.
          </p>
          <div className="flex items-center gap-2" data-id="element-294">
            <span className="text-[12px] font-bold text-[#1a1a1a] font-sans uppercase tracking-wide" data-id="element-295">
              Robert K.
            </span>
            <span className="text-[12px] text-[#888] font-sans" data-id="element-296">
              Columbus, OH
            </span>
            <BadgeCheck size={12} className="text-[#8B2500]" data-id="element-297" />
          </div>
        </div>

        <div className="relative pl-6" data-id="element-298">
          <span className="absolute left-0 top-0 text-[40px] leading-none text-[#E5E5E0] font-serif font-bold" data-id="element-299">
            "
          </span>
          <p className="text-[18px] italic text-[#1a1a1a] mb-3 font-serif leading-relaxed" data-id="element-300">
            My husband said "you're not holding the railing anymore." I hadn't
            even realized it. The exercises are so simple—chair, wall, band—but
            the sequence makes all the difference.
          </p>
          <div className="flex items-center gap-2" data-id="element-301">
            <span className="text-[12px] font-bold text-[#1a1a1a] font-sans uppercase tracking-wide" data-id="element-302">
              Linda S.
            </span>
            <span className="text-[12px] text-[#888] font-sans" data-id="element-303">Tampa, FL</span>
            <BadgeCheck size={12} className="text-[#8B2500]" data-id="element-304" />
          </div>
        </div>
      </div>
    </section>;
}